import angular from 'angular';
import { BRAND_NAME } from '../../controller/environment'

export function brandNameFilter (input) {
  return input.replace('${BRAND_NAME}', BRAND_NAME)
}

angular.module("core.application.main")
  .filter("core_application_main_filter_brandName", () => brandNameFilter);
